module.exports = __webpack_public_path__ + "img/login_graphic.73f783f3.svg";